import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Icon / 24&#195;&#151;24 / PlusL">
        <path
          id=" "
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 3V11H3V13H11V21H13V13H21V11H13V3H11Z"
          fill="#21201F"
        />
      </g>
    </svg>
  )
}
